import type { CognitoUserPoolConfig } from "@aws-amplify/core";

interface KeysEnvironment {
  hubspot: string;
  hubspotFormIds?: string;
  roxKey: string;
}

interface Environment {
  name: string;
  auth: CognitoUserPoolConfig;
  datadog: {
    applicationId: string;
    clientToken: string;
  };
  posthog: {
    apiKey: string;
    apiHost: string;
  };
  chameleon: {
    accountToken: string;
  };
  keys: KeysEnvironment;
  restApi: string;
  customDocumentSuffix: string;
}

const oauthUrls = () => {
  const signInSuffix = "/auth/sso-login";
  const signOutSuffix = "/auth/sso-sign-out/";

  const urls = (() => {
    if (process.env.VITE_ENV_NAME === "prod") {
      return ["https://agent.covertree.com"];
    }

    if (process.env.VITE_ENV_NAME === "stag") {
      return ["https://agent.staging.covertree.com"];
    }

    return ["http://localhost:3001"];
  })();

  return {
    redirectSignIn: urls.map((url) => `${url}${signInSuffix}`),
    redirectSignOut: urls.map((url) => `${url}${signOutSuffix}`),
  };
};

const environment: Environment = {
  name: process.env.VITE_ENV_NAME!,
  auth: {
    loginWith: {
      email: true,
      oauth: {
        ...oauthUrls(),
        domain: process.env.VITE_AWS_COGNITO_USER_POOL_DOMAIN!,
        scopes: [
          "aws.cognito.signin.user.admin",
          "openid",
          "email",
          "phone",
          "profile",
        ],
        responseType: "code",
      },
    },
    userPoolId: process.env.VITE_AWS_COGNITO_USER_POOL_ID!,
    userPoolClientId: process.env.VITE_AWS_COGNITO_USER_POOL_CLIENT_ID!,
  },
  datadog: {
    applicationId: process.env.VITE_DATADOG_APPLICATION_ID!,
    clientToken: process.env.VITE_DATADOG_CLIENT_TOKEN!,
  },
  posthog: {
    apiKey: process.env.VITE_POSTHOG_API_KEY!,
    apiHost: process.env.VITE_POSTHOG_API_HOST!,
  },
  chameleon: {
    accountToken: process.env.VITE_CHAMELEON_ACCOUNT_TOKEN!,
  },
  keys: {
    hubspot: process.env.VITE_HUBSPOT_PORTAL_ID!,
    hubspotFormIds: process.env.VITE_HUBSPOT_FORM_IDS,
    roxKey: process.env.VITE_ROX_KEY || "642ebc81beef223a03f8652e",
  },
  restApi: process.env.VITE_AWS_REST_API_URL!,
  customDocumentSuffix:
    process.env.VITE_CUSTOM_POLICY_DOCUMENT_DISPLAY_NAME_SUFFIX!,
};

export default environment;
